export default "__VITE_ASSET__Dg2T3MNO__"